"use strict";

exports.__esModule = true;
exports.themePriority = exports.themePriorities = void 0;
var themePriority = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
  TRIVIAL: 'trivial',
  LOW_ICON: 'lowIcon'
};
exports.themePriority = themePriority;
var themePriorities = Object.values(themePriority);
exports.themePriorities = themePriorities;